import { encrypt, generateSSOToken } from '../paymentEncryption';
import {
  paymentus_encrypted_url,
} from '../../../../constants/paymentConstants';
import { CUSTOMER_NAME, PAYMENT_AVAILABLE } from '../../../../constants/companyConfig';

export async function generatePaymentIframeHTML({
  paymentType,
  subscriberId,
  guarantorId,
  personId,
  emailId ,
  firstname,
  lastname ,
  amount,
  autopay,
  externalReference,
  timestamp,
  accessToken
}) {
  // Check if payment is available for this company
  if (!PAYMENT_AVAILABLE) {
    throw new Error('Payment is not available for this company');
  }

  const ssoData = {
    customerName: CUSTOMER_NAME,
    firstName: firstname,
    lastName: lastname,
    email: emailId,
    pmCategory: paymentType,
    externalReference,
    postbackUrl: `${process.env.REACT_APP_PAYMENT_BASE_URL}/payment/paymentus/callback-url`,
    timestamp,
    nickname: false,
    primaryPM: false,
    doNotSave: true,
    saveToWallet: true
  };

  const iframeUrl = await paymentus_encrypted_url(ssoData, accessToken);
  
  if (!iframeUrl) {
    throw new Error('Failed to generate Payment iframe URL');
  }
  
  return `<iframe src="${iframeUrl}" style="width:100%; height:100%; border:none;" ></iframe>`;
}

